export const REAL_LOGS_PLACEHOLDER = "REAL_LOGS_PLACEHOLDER";
export const FINAL_LOG_TEMPLATE = "FINAL_LOG_TEMPLATE";

export const integrationLogsMap: Record<string, string[]> = {
  FunctionDecorators: [
    "Initializing Opik demo console",
    "%cmd% pip install opik",
    "%cmd% python function_decorators_example.py",
    "Hello! I'm here to assist you with any specific information you may be looking for or help you explore topics of interest. How can I assist you today?",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  OpenAI: [
    "Initializing Opik demo console",
    "%cmd% pip install openai",
    "%cmd% python openai_example.py",
    "Code and circuits hum",
    "AI engineers give life",
    "Innovation blooms",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  Anthropic: [
    "Initializing Opik demo console",
    "%cmd% pip install anthropic",
    "%cmd% python anthropic_example.py",
    "Here's a haiku about AI engineering:",
    "Code flows like rivers",
    "Neural nets learn and grow deep",
    "Machines wake to thin",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  Bedrock: [
    "Initializing Opik demo console",
    "%cmd% pip install awscli",
    "%cmd% python bedrock_example.py",
    "Code crafted with care",
    "Intelligence born of lines",
    "Future's subtle dance",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "Logged traces to your Opik dashboard, [view them here](https://example.com)",
    "%cmd% sh shutdown_console.sh",
  ],
  Gemini: [
    "Initializing Opik demo console",
    "%cmd% pip install gemini-sdk",
    "%cmd% python gemini_example.py",
    "Code and knowledge fuse,",
    "Creating minds of steel and grace,",
    "AI's future blooms.",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  LangChain: [
    "Initializing Opik demo console",
    "%cmd% pip install langchain",
    "%cmd% python langchain_example.py",
    "Code and circuits merge",
    "Creating intelligence",
    "AI engineering",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  LangGraph: [
    "Initializing Opik demo console",
    "%cmd% pip install langgraph",
    "%cmd% python langgraph_example.py",
    "{'question': 'Hello, how are you?', 'classification': 'greeting', 'response': 'Hello! How can I help you today?'}",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  LlamaIndex: [
    "Initializing Opik demo console",
    "%cmd% pip install llama-index",
    "%cmd% python llamaindex_example.py",
    "The author focused on writing short stories and programming during his time before college.",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  Haystack: [
    "Initializing Opik demo console",
    "%cmd% pip install haystack",
    "%cmd% python haystack_example.py",
    "Code and circuits spin",
    "Artificial minds awaken",
    "AI engineers",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  LiteLLM: [
    "Initializing Opik demo console",
    "%cmd% pip install litellm",
    "%cmd% python litellm_example.py",
    "Code evolves with time",
    "AI minds solve problems great",
    "Technology thrives",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  Ragas: [
    "Initializing Opik demo console",
    "%cmd% pip install ragas",
    "%cmd% python ragas_example.py",
    "Answer Relevancy score: 0.999",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  Groq: [
    "Initializing Opik demo console",
    "%cmd% pip install groq",
    "%cmd% python groq_example.py",
    "Here is a haiku about AI engineering:",
    "Code and circuit blend",
    "Intelligent life takes form",
    "In silicon cells glow",
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
  DSPy: [
    "Initializing Opik demo console",
    "%cmd% pip install dspy",
    "%cmd% python dspy_example.py",
    `Prediction(
        reasoning='The meaning of life is a philosophical question that has been contemplated by humans for centuries. Different cultures, religions, and individuals have proposed various interpretations. Some suggest that the meaning of life is to seek happiness, fulfillment, and personal growth, while others believe it is about serving a higher purpose or contributing to the well-being of others. Ultimately, the meaning of life may vary from person to person, shaped by personal experiences, beliefs, and values.',
        answer="The meaning of life is subjective and can vary greatly among individuals. It may involve seeking happiness, personal growth, and contributing to the well-being of others, or fulfilling a higher purpose, depending on one's beliefs and experiences."
    )`,
    REAL_LOGS_PLACEHOLDER,
    FINAL_LOG_TEMPLATE,
    "%cmd% sh shutdown_console.sh",
  ],
};
